import React, { createContext, type FC } from "react";

import {
  type TranslationHookProviderProps,
  type UseTranslationHook,
} from "./types";
import { useTranslationFromServerSide } from "./useTranslation";

export const TranslationHookContext = createContext<UseTranslationHook>(null!);

const TranslationHookProvider: FC<TranslationHookProviderProps> = ({
  children,
}) => {
  return (
    <TranslationHookContext.Provider value={useTranslationFromServerSide}>
      {children}
    </TranslationHookContext.Provider>
  );
};

export default TranslationHookProvider;
